// extracted by css-extract-rspack-plugin
export default {"root":"W5Ui7H","sectionTitle":"IcYmIv","box":"l7U9sk","labelText":"AEkMX6","irreversible":"SeICea","learnMore":"YZLBaS"};